import i18n, { options } from 'i18next';

const filtersMeta = [
  {
    name: 'patientName',
    displayName: i18n.t('StudyList:PatientName'),
    inputType: 'Text',
    isSortable: true,
    gridCol: 4,
    padding: 'px-4 py-2',
  },
  {
    name: 'studyDate',
    displayName: i18n.t('StudyList:StudyDate'),
    inputType: 'DateRange',
    isSortable: true,
    gridCol: 4,
    padding: 'px-4 py-2',
  },
  {
    name: 'Report',
    displayName: i18n.t('StudyList:Report'),
    inputType: 'None',
    isSortable: false,
    gridCol: 2,
    padding: 'px-4 py-2',
  },
  {
    name: 'assignTo',
    displayName: 'Assigned To',
    inputType: 'None',
    isSortable: false,
    gridCol: 3,
    padding: 'px-4 py-2',
  },
  {
    name: 'distribution',
    displayName: 'Distribution',
    inputType: 'None',
    isSortable: false,
    gridCol: 2,
    padding: 'px-4 py-2',
  },
  {
    name: 'reportStatus',
    displayName: i18n.t('StudyList: Status'),
    inputType: 'MultiSelect',
    isSortable: false,
    inputProps: {
      options: [
        { value: 'Draft', label: 'Draft' },
        { value: 'Preliminary', label: 'Preliminary' },
        { value: 'Finalized', label: 'Finalized' },
      ],
    },
    gridCol: 3,
    padding: 'px-4 py-2',
  },
  {
    name: 'reportType',
    displayName: i18n.t('StudyList: Type'),
    inputType: 'MultiSelect',
    isSortable: false,
    inputProps: {
      options: [
        { value: 'Stress Echo', label: 'Stress Echo' },
        { value: 'ECHO', label: 'ECHO' },
        { value: 'Dobutamine stress echo', label: 'Dobutamine stress echo' },
        // { value: 'Stress Echo 2', label: 'Stress Echo 2' },
        // { value: 'Transthoracic Echo 2', label: 'Transthoracic Echo 2' },
        // { value: 'Transthoracic Echo', label: 'Transthoracic Echo' },
        // { value: 'Transthoracic Echocardiogram', label: 'Transthoracic Echocardiogram' },
      ],
    },
    gridCol: 2,
    padding: 'px-4 py-2',
  },
  {
    name: 'Dicom Mode',
    displayName: i18n.t('StudyList:Mode'),
    inputType: 'None',
    isSortable: false,
    inputProps: {
      options: [{ value: 'Awaiting review', label: 'Awaiting review' }],
    },
    gridCol: 2,
    padding: 'px-4 py-2 pl-6',
  },
  {
    name: 'Interesting Cases',
    displayName: i18n.t('StudyList:Interesting Cases'),
    inputType: 'None',
    isSortable: false,
    gridCol: 2,
    padding: 'px-4 py-2',
  },
];

export default filtersMeta;
